import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    marginLeft: 'auto',
    marginRight: theme.spacing(2.5),
    '& button + button': {
      marginLeft: theme.spacing(0.625),
    },
  },
  button: {
    width: theme.spacing(2.75),
    minWidth: theme.spacing(2.75),
    height: theme.spacing(2.75),
    borderRadius: 0,
    padding: 0,
    border: `${theme.spacing(0.125)}px solid ${theme.palette.gray.main}`,
  },
  icon: {
    height: theme.spacing(1),
  },
  rotateIcon: {
    transform: 'rotate(180deg)',
  },
  currentPage: {
    borderColor: theme.palette.secondary.main,
  },
}));
